import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import NewsBg from '../../images/news/news.jpg';
import JornalNoticias from '../../images/news/jornalNegocios.jpg';
import JornalEconomico from '../../images/news/jornalEconomico.png';
import TSF from '../../images/news/tsf.svg';
import RTP from '../../images/news/rtp.jpg';
import Observador from '../../images/news/observador.jpg';



const newsMentions = [
  {
    title: "Porto students develop electric-powered unmanned boat.",
    source: "Observador",
    date: "June 2026",
    image: Observador,
    link: "https://observador.pt/2026/06/26/estudantes-do-porto-desenvolvem-barco-nao-tripulado-movido-a-energia-eletrica/",
  },
  {
    title: "FEUP students launch first solar boat with hull in natural fibers",
    source: "Jornal de Negócios",
    date: "June 2025",
    image: JornalNoticias,
    link: "https://www.jornaldenegocios.pt/sustentabilidade/ambiental/detalhe/estudantes-da-feup-lancam-primeiro-barco-solar-com-casco-em-fibras-naturais",
  },
  {
    title: "Engineering Faculty presents first competition solar boat from the northern region ",
    source: "O Jornal Económico",
    date: "June 2025",
    image: JornalEconomico,
    link: "https://jornaleconomico.sapo.pt/noticias/faculdade-de-engenharia-apresenta-primeiro-barco-solar-de-competicao-da-regiao-norte/",
    type: "Article"
  },
  {
    title: "Atlântico ready to navigate solar-powered from FEUP to the world",
    source: "TSF",
    date: "June 2025",
    image: TSF,
    link: "https://noticias.up.pt/feup/tsf-atlantico-pronto-a-navegar-movido-a-energia-solar-da-feup-para-o-mundo/",
    },
  {
    title: "FEUP students build innovative prototype of a sustainable solar boat",
    source: "RTP",
    date: "June 2025",
    image: RTP,
    link: "https://www.rtp.pt/play/p14264/e860912/portugal-em-direto/1345557",
  }
];

function News() {
  const [activeIndex, setActiveIndex] = useState(3);
  const [isPaused, setIsPaused] = useState(false);
  const scrollBlocked = useRef(false);

  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % newsMentions.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [isPaused]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        setActiveIndex((prev) => (prev - 1 + newsMentions.length) % newsMentions.length);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        setActiveIndex((prev) => (prev + 1) % newsMentions.length);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [newsMentions.length]);

  useEffect(() => {
    const handleWheel = (e) => {
      if (Math.abs(e.deltaX) > 10 && !scrollBlocked.current) {
        e.preventDefault();
        scrollBlocked.current = true;
        if (e.deltaX > 0) {
          setActiveIndex((prev) => (prev + 1) % newsMentions.length);
        } else {
          setActiveIndex((prev) => (prev - 1 + newsMentions.length) % newsMentions.length);
        }
        setTimeout(() => { scrollBlocked.current = false; }, 500);
      }
    };
    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => window.removeEventListener('wheel', handleWheel);
  }, [newsMentions.length]);

  const activeNews = newsMentions[activeIndex];

  return (
    <div 
      className="relative flex flex-col items-center justify-center w-full min-h-screen pt-32 pb-16 overflow-hidden"
      style={{
        backgroundImage: `linear-gradient(to bottom, rgba(15, 23, 42, 0.3), rgba(15, 23, 42, 0.8)), url(${NewsBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
    >
        <div className="w-full max-w-5xl px-6 z-20">
          <div className="flex justify-between items-center mb-8">
            <h1 className="font-custom md:text-7xl text-3xl font-bold text-white">News</h1>
            <Link
              to="/news"
              className="px-5 py-2.5 bg-white text-slate-900 font-bold rounded-full hover:bg-mainBlue hover:text-white transition-all duration-300 hover:scale-105 font-custom"
            >
              View All News
            </Link>
          </div>
        
        <div className="flex flex-col md:flex-row bg-slate-900/60 backdrop-blur-xl rounded-[2rem] border border-white/10 overflow-hidden shadow-2xl min-h-[350px]">
          
           <div className="w-full md:w-3/5 p-6 md:p-10 flex flex-col justify-center gap-4">
             <div className="flex items-center gap-4">
                <div className="w-28 h-14 bg-white/10 rounded-lg overflow-hidden border border-white/10 flex items-center justify-center p-1">
                   <img src={activeNews.image} alt={activeNews.source} className="max-w-full max-h-full object-contain" />
                </div>
                <div className="flex flex-col gap-1">
                   <span className="text-blue-200 text-xs font-bold uppercase tracking-widest font-custom">{activeNews.source}</span>
                </div>
             </div>

            <h2 className="text-2xl md:text-3xl font-bold text-white leading-tight font-custom">
              {activeNews.title}
            </h2>
            
            <p className="text-gray-400 font-medium font-custom">{activeNews.date}</p>
            
            <a 
              href={activeNews.link} 
              target="_blank" 
              className="mt-2 px-5 py-2.5 bg-white text-slate-900 font-bold rounded-full w-fit hover:bg-mainBlue hover:text-white transition-all duration-300 hover:scale-105 font-custom"
            >
              View More
            </a>
          </div>

          <div className="w-full md:w-2/5 bg-slate-900/40 border-t md:border-t-0 md:border-l border-white/5 p-4 flex flex-col gap-1 justify-center">
             {newsMentions.map((item, idx) => {
               const isActive = idx === activeIndex;
               return (
                 <button
                   key={idx}
                   onClick={() => setActiveIndex(idx)}
                   className={`flex items-center gap-3 w-full p-3 rounded-xl transition-all duration-300 ${
                     isActive 
                       ? 'bg-mainBlue/20 shadow-inner scale-[1.02]' 
                       : 'hover:bg-white/5 hover:scale-[1.01]'
                   }`}
                 >
                   <div className={`w-1.5 h-1.5 rounded-full transition-all shrink-0 ${
                     isActive ? 'bg-mainBlue shadow-[0_0_8px_#2B556B]' : 'bg-gray-600'
                   }`} />
                   <span className={`text-sm font-semibold transition-colors font-custom truncate ${
                     isActive ? 'text-white' : 'text-gray-400'
                   }`}>
                     {item.source}
                   </span>
                 </button>
               );
             })}
          </div>

        </div>
        
        <div className="mt-8 flex items-center justify-center gap-2">
          {newsMentions.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setActiveIndex(idx)}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                idx === activeIndex ? 'bg-mainBlue w-6' : 'bg-white/30 w-1.5 hover:bg-white/50'
              }`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default News;
